<template>
  <div class="page-price-info">
    <div class="charge-price-info-container">
      <div class="charge-price-info-container-info">
        <div class="charge-price-info-container-info-tag">电价、服务费</div>
        <div class="charge-price-info-container-info-table-header">
          <div class="header-cell">时段</div>
          <div class="header-cell">充电费</div>
          <div class="header-cell">服务费</div>
        </div>
        <div class="charge-price-info-container-info-table-content"
             v-for="(item, index) in elecsFeeList" :key="index">
          <div class="content-cell">
            {{$common.formatDelayTime(item.beginTime)}}～{{$common.formatDelayTime(item.endTime)}}
          </div>
          <div class="content-cell">{{item.slotElecPrice}} 元/度</div>
          <div class="content-cell">{{item.slotServicePrice}} 元/度</div>
        </div>
      </div>
      <div class="charge-price-info-container-info" style="margin-top: 0.2rem">
        <div class="charge-price-info-container-info-tag">延时费信息</div>
        <div class="charge-price-info-container-info-table-header">
          <div class="header-cell">时段</div>
          <div class="header-cell">延时费率</div>
        </div>
        <div class="charge-price-info-container-info-table-content"
             v-for="(item, index) in delayFeeList" :key="index">
          <div class="content-cell">
            {{$common.formatDelayTime(item.beginTime)}}～{{$common.formatDelayTime(item.endTime)}}
          </div>
          <div class="content-cell">{{item.slotDelayPrice}}元/分钟</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChargeFee } from '../../common/api';

export default {
  name: 'price-info',
  data () {
    return {
      chargeFeeVo: {details: []},
      chargeDelayFeeVo: {details: []},
      elecsFeeList: [],
      delayFeeList: [],
    };
  },
  mounted () {
    let orderNo = this.$common.query('orderNo');
    if (!this.$common.isEmpty(orderNo)) {
      this.getChargeFee(orderNo);
    } else {
      let priceInfo = this.$common.get('priceInfo');
      console.log(priceInfo)
      if (priceInfo) {
        this.chargeFeeVo = this.$common.wrapFee(priceInfo.chargeFeeVo);
        this.chargeDelayFeeVo = this.$common.wrapDelayFee(priceInfo.chargeDelayFeeVo) || {details: []};
      }
    }
  },
  methods: {
    getChargeFee (orderNo) {
      getChargeFee({
        orderNo: orderNo
      }).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          this.elecsFeeList = data.data[0].elecsFeeList;
          this.delayFeeList = data.data[0].delayFeeList;
          // this.chargeFeeVo = this.$common.wrapFee(data.data[0].chargeFeeVo);
          // this.chargeDelayFeeVo = this.$common.wrapDelayFee(data.data[0].chargeDelayFeeVo) || {details: []};
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-price-info{
  width: 100%;
  height: 100%;
  padding: 0.25rem 0.23rem;
  box-sizing: border-box;
  .charge-price-info-container {
    padding: 0.25rem 0.23rem;
    box-shadow: 0 0 0.07rem 0 rgba(0, 0, 0, 0.23);
    border-radius: 10px;
    // .charge-price-info-container-info {
    //   .charge-price-info-container-info-tag {
    //     color: #666666;
    //     font-size: 0.28rem;
    //     margin-bottom: 0.21rem;
    //   }
    //   .charge-price-info-container-info-table-header {
    //     background: rgba(20, 204, 128, 0.15);
    //     display: flex;
    //     .header-cell {
    //       flex: 1;
    //       padding: 0.08rem 0;
    //       text-align: center;
    //     }
    //   }
    //   .charge-price-info-container-info-table-content {
    //     background: #F8F4F5;
    //     display: flex;
    //     margin-top: 0.1rem;
    //     .content-cell {
    //       flex: 1;
    //       padding: 0.15rem 0;
    //       text-align: center;
    //     }
    //   }
    // }
    .charge-price-info-container-info {
  .charge-price-info-container-info-tag {
    color: #666666;
    font-size: 0.28rem;
    margin-bottom: 0.21rem;
  }
  .charge-price-info-container-info-table-header {
    background: rgba(20, 204, 128, 0.15);
    display: flex;
    margin-bottom: 0.04rem;
    .header-cell {
      flex: 1;
      padding: 0.08rem 0;
      text-align: center;
    }
    .header-cell.th {
      text-align: left;
      padding-left: 0.1rem;
    }
  }
  .charge-price-info-container-info-table-content {
    display: flex;
    margin-bottom: 0.04rem;
    .content-cell {
      flex: 1;
      padding: 0.15rem 0;
      text-align: center;
      margin-right: 0.04rem;
      background: #f8f4f5;
    }
    .content-cell:last-child {
      margin-right: 0;
    }
  }
}
  }
}
</style>
